export default __webpack_public_path__ + "static/media/Review-orders.eb1542ee.jpg";